import React from "react";
import { Controller, Scene } from 'react-scrollmagic';
import { Tween, Timeline } from 'react-gsap';
import Media from 'react-media';

import "./IndexBand.scss";

import pho_02q from "../../asset/images/pho_02q.jpg";

// 首页中部banner
class IndexBand extends React.Component {
  render() {
    return (
      <div>
        <Media query="(min-width: 701px)" render={() =>
            (
              <Controller>
            <div className="section" />
            <Scene
              // indicators={true}
              duration="200%"
              triggerHook="onEnter"
            >
              <Timeline
                wrapper={<div className="parallax" />}
              >
                <Tween
                  position="0"
                  from={{
                    yPercent: -80,
                  }}
                  to={{
                      yPercent: -10,
                  }}
                >
                  <img src={pho_02q} alt="" />
                </Tween>
                <Tween
                position="0"
                from={{
                  top: '-40%',
                  scale: 1.5,
                }}
                to={{
                  top: '90%',
                  scale: 2,
                }}
                >
                  <div className="indexband_word">
                    <div className="indexband_title">涵智博雅</div>
                    <div className="indexband_content">引领工业用能数字化实践</div>
                  </div>
                </Tween>
              </Timeline>
            </Scene>
            <div className="section" />
          </Controller>
          )}
        />
        <Media query="(max-width: 700px)" render={() =>
          (
            <div className="backimg">
              <div className="indexband_word">
                <div className="indexband_title">涵智博雅</div>
                <div className="indexband_content">引领工业用能数字化实践</div>
              </div>
            </div>
          )}
        />
      </div>
    )
  }
}

export default IndexBand
